<template>
  <div id="faqpage">
    <!-- <scmenueng></scmenueng> -->
    <div>
      <div class="menubutton_wrapper">
        <!-- <div class="menubutton" @click="hidemenu"> -->
        <div class="menubutton" @click="togglemenu">
          <i  class="fa fa-bars" aria-hidden="true"></i>
        </div>
        <a href="/en"><img v-if="largescreen===false" src="/assets/img/sslogo.svg" alt="スカンジナビアサービス"></a>
      </div>
      <!-- <div v-show="largescreen" id="app" class="horizontal-logo"> -->
      <div v-if="largescreen===true" class="horizontal-logo">
        <!-- <router-link to="/"><img src="/assets/img/sslogo.svg"></router-link> -->
        <a href="/"><img src="/assets/img/sslogo.svg" alt="スカンジナビアサービス"></a>
      </div>
      <p style="padding-top:48px;">　</p>
    </div>


    <div class="centered">
      <section class="menu-section" v-show="showMenu">
        <nav id="single-nav" class="single-nav topmenu" role="navigation">
          <ul>
            <li><a href="/en">Home</span></a></li>
            <li><a href="/en/products">Products</a></li>
            <li><a href="/en/support">Support</a></li>
            <li><a href="/en/kaisha">Company Profile</a></li>
            <li><a href="/en/taiken">Free Trial</a></li>
            <li><a href="/en/onlinestore">Online Store</a></li>
            <li><a href="/en/faq">FAQ</a></li>
            <li><a href="/en/contact">Contact</a></li>
            <li><a href="/">日本語<span>Japanese</span></a></li>
          </ul>
        </nav><!-- #single-nav .single-nav -->
      </section><!-- menu-section -->
    </div><!-- .centered -->
    <div class="menu-back"></div>


    <div>
      <div class="main-heading inner">
        <!-- <div class="inner"> -->
	<p class="sub">Frequently Asked Questions</p>
	<h2>Q & A</h2>
                  </div>

      <section class="qa inner clearfix">
        <p class="qa_tx clearfix">"Is the machine easy to operate?" "What should I do if it breaks down?"—We have compiled the most common questions from our customers in a Q&A format. We hope this helps in resolving any issues or concerns you may have. If you have any questions that are not covered on this page or if you would like more detailed information, please feel free to contact us through the inquiry form.
          <router-link to="/contact"><span class="btn">Contact Form</span></router-link>
        </p>

        <div class="clearfix">
          <h3>List of FAQs</h3>
          <dl class="qa_list clearfix">
	    <dt>Device-related questions</dt>
	    <dd><router-link to="#q01">Q. What is the Japan Esthetic Association Certification?</router-link></dd>
	    <dd><router-link to="#q02">Q. I often hear the terms "domestically produced" and "purely domestically produced." What is the difference between the two?</router-link></dd>
	    <dd><router-link to="#q03">Q. What are the advantages of a purely domestically produced product?</router-link></dd>
	    <dd><router-link to="#q04">Q. Are the devices user-friendly?</router-link></dd>
	    <dd><router-link to="#q05">Q. As a beginner, is this equipment suitable for me?</router-link></dd>
	    <dd><router-link to="#q06">Q. What are the available purchase methods?</router-link></dd>
          </dl>
          <dl class="qa_list clearfix">
	    <dt>Support-related questions</dt>
	    <dd><router-link to="#q07">Q. What kind of after-sales service is provided?</router-link></dd>
	    <dd><router-link to="#q08">Q. Do you offer support for newly established businesses?</router-link></dd>
	    <dd><router-link to="#q09">Q. What is the warranty period for the equipment?</router-link></dd>
	    <dd><router-link to="#q10">Q. What should I do if the equipment malfunctions?</router-link></dd>
          </dl>
        </div>

        <h4>Device-related questions</h4>

        <!--  set  -->
        <div class="waku mt20" id="q01">
          <dl class="qa_box">
            <dt>What is the Japan Esthetic Association Certification?</dt>
            <dd>The Esthetic Device Certification is a mark granted only to devices that pass both a "product test" based on common and individual standards, as well as a "system audit" that verifies the safety of the device and how well it considers the user. Our Powerlite series of hair removal devices have received certification from the Japan Esthetic Organization (JEO) and have passed the Beauty Light Device Conformity Inspection System, qualifying them as certified devices by the Japan Esthetic Promotion Association (JEPA).
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        <!--  set  -->
        <div class="waku mt20" id="q02">
          <dl class="qa_box">
            <dt>I often hear the terms "domestically produced" and "purely domestically produced." What is the difference between the two?</dt>
            <dd>In fact, even if foreign parts are used, if the final assembly of the equipment is done in Japan, it can still be considered a domestic product. On the other hand, a product is considered purely domestic if the development, manufacturing, and assembly of all parts are carried out entirely within Japan. Our machines are developed in-house and are carefully manufactured and assembled in Japan, making them purely domestic products.
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        <!--  set  -->
        <div class="waku mt20" id="q03">
          <dl class="qa_box">
            <dt>What are the advantages of a purely domestically produced product?</dt>
            <dd>Our comprehensive service includes parts management and repair, guaranteeing timely part replacements for years to come. With precision, durability, and safety as our top priorities, our machines offer long-lasting performance.
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        <!--  set  -->
        <div class="waku mt20" id="q04">
          <dl class="qa_box">
            <dt>Are the devices user-friendly?</dt>
            <dd>Yes, our equipment is designed to be user-friendly, making it accessible to everyone. Additionally, we provide comprehensive support both during and after installation to ensure your peace of mind.
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        <!--  set  -->
        <div class="waku mt20" id="q05">
          <dl class="qa_box">
            <dt>As a beginner, is this equipment suitable for me?</dt>
            <dd>Yes, we offer thorough training upon installation, enabling even novice users to operate the machine efficiently.
            </dd>
          </dl>
        </div>
        <!--  //set  -->
        <!--  set  -->
        <div class="waku mt20" id="q06">
          <dl class="qa_box">
            <dt>What are the available purchase methods?</dt>
            <dd>Payment methods include cash and credit cards. We also have a range of financing plans available. Please don't hesitate to ask for more details.
            </dd>
          </dl>
        </div>
        <!--  //set  -->


        <h5>Support-related questions</h5>

        <!--  set  -->
        <div class="waku mt20" id="q07">
          <dl class="qa_box">
            <dt>What kind of after-sales service is provided?</dt>
            <dd>Upon installation, we provide a comprehensive training program designed for beginners. Furthermore, we offer ongoing technical support and advanced training sessions to enhance your skills. To assist in your business, we also supply a variety of marketing materials, such as foundational knowledge of hair removal and skincare, menu planning guidance, and promotional tools like flyers, posters, and POP materials. Please note that some of these resources may incur additional fees.
            </dd>
          </dl>
        </div>
        <!--  //set  -->

        <!--  set  -->
        <div class="waku mt20" id="q08">
          <dl class="qa_box">
            <dt>Do you offer support for newly established businesses?</dt>
            <dd>Drawing upon two decades of expertise, we provide comprehensive support to help you establish your business successfully. Whether you are new to the beauty industry or transitioning from another field, our team is committed to guiding you through the process. Our support encompasses a wide range of areas, including industry trends, salon management, and general business operations.
            </dd>
          </dl>
        </div>
        <!--  //set  -->

        <!--  set  -->
        <div class="waku mt20" id="q09">
          <dl class="qa_box">
            <dt>What is the warranty period for the equipment?</dt>
            <dd>The POWERLITE series comes with a 2-year warranty. Please note that warranty periods may vary depending on the specific model. Feel free to contact us for more details.
            </dd>
          </dl>
        </div>
        <!--  //set  -->

        <!--  set  -->
        <div class="waku mt20" id="q10">
          <dl class="qa_box">
            <dt>What should I do if the equipment malfunctions?</dt>
            <dd>Should you encounter any issues or malfunctions with your equipment, please do not hesitate to contact our company. We offer daily service call support, including weekends and public holidays (9:00–18:00), and guarantee a response within 48 hours. Our engineers will promptly address the problem. Additionally, we have standby replacement units available to minimise downtime. (Please note that availability may vary depending on inventory.)
            </dd>
          </dl>
        </div>
        <!--  //set  -->
      </section>
    </div>

    <scfootereng></scfootereng>
  </div>
</template>

<script   src="https://code.jquery.com/jquery-2.2.4.min.js"   integrity="sha256-BbhdlvQf/xTY9gja0Dq3HiwQF8LaCRTXxZKRutelT44="   crossorigin="anonymous"></script>
<script>

 export default {
   name: 'faqeng',
   props: {
     largescreen: {
       type: Boolean
     }
   },
   data () {
     return {
       /* largescreen: 'true', */
       showMenu: 'false',
       locallargescreen: 'true'
   }},
   components: {
     scmenueng: () => import('../components/scMenuEng.vue'),
     scfootereng: () => import('../components/scFooterEng.vue')
   },
   updated() {
     this.$nextTick(function () {
       // Code that will run only after the
       // entire view has been re-rendered
       if (this.largescreen) {
         this.locallargescreen = true;
         this.showMenu = true;
       }
       console.log(`updated: largescreen is ${this.largescreen}`);
       console.log(`updated: locallargescreen is ${this.locallargescreen}`);
       console.log(`updated: showMenu is ${this.showMenu}`);

     })
   },

   /* http://peccu.hatenablog.com/entry/2017/11/18/000000
      Vue.js+VueRouterを使っているときに#idでページ内を移動する */
   watch: {
     '$route': function (n, o) {
       if (n.hash.match(/^#/)) {
         document.getElementById(n.hash.replace(/^#/, '')).scrollIntoView()
       }
       console.log('new, old', [n.hash, o.hash])
     }
   },
   mounted () {
     if (this.$route.hash.match(/^#/)) {
       document.getElementById(this.$route.hash.replace(/^#/, '')).scrollIntoView()
     }
     this.windowWidth = window.innerWidth;
     if (this.windowWidth < 600) {
       this.locallargescreen = false;
     };
     console.log(`mounted: largescreen is ${this.largescreen}`);

     /*
        At startup on small screens we want to hide menu-section (i.e the drop down menu).
        'largescreen' is true even in small screens here (at mounted).
        It becomes false after this from App.vue. (see console)
        So use window.innerWidth and make our own largescreen named locallargescreen.
        And set showMenu according to locallargescreen
      */

     console.log(`mounted: windowWidth is ${this.windowWidth}`);
     console.log(`mounted: locallargescreen is ${this.locallargescreen}`);

     if (this.locallargescreen) {
       this.showMenu = true;
     } else {
       this.showMenu = false;
     }
     console.log(`mounted: showMenu is ${this.showMenu}` );
   },
   methods: {
     togglemenu() {
       this.showMenu = !this.showMenu
       console.log(`togglemenu: showMenu is ${this.showMenu}`);
     },

   }
 }



</script>

<style lang="scss">
 #scmenu {
   display: none;
 }
</style>
<style lang="scss" scoped>
 #single-nav {
   // margin-left: 15px;
   margin-left: 10px;
 }
 #faqpage {
   width: 100%;
 }

 @charset "UTF-8";
 dl,
 dt,
 dd,
 section {
   margin: 0;
   padding: 0;
   color: #161515;
   font-size: 16px;
   font-weight: normal;
   font-style: normal;
   font-family: "ヒラギノ角ゴシック Pro", "Hiragino Kaku Gothic Pro", "ＭＳ Ｐゴシック", "MS PGothic", 'メイリオ', Meiryo, Osaka, sans-serif;
   line-height: 1.8;
   vertical-align: baseline;
   background: transparent;
   box-sizing: border-box;
   border: none;
 }

 body {
   min-width: 960px;
 }

 a,
 article,
 aside,
 canvas,
 details,
 figcaption,
 figure,
 header,
 footer,
 main,
 menu,
 nav,
 section,
 summary {
   display: block;
 }

 img {
   border: 0;
   display: block;
   height: auto;
 }

 table {
   border-spacing: 0;
   border-collapse: collapse;
 }

 ul,
 li {
   list-style: none;
 }

 a {
   color: #161515;
   text-decoration: none;
   -webkit-transition: 02s ease;
   -moz-transition: 0.2s ease;
   -o-transition: 0.2s ease;
   transition: 0.2s ease;
 }

 a:hover {
   opacity: 0.8;
 }

 .inner {
   width: 960px;
   margin: 0 auto;
 }
 /* clearfix */

 .clearfix {
   zoom: 1;
 }

 .clearfix:after {
   content: "";
   display: block;
   clear: both;
 }

 .clear {
   clear: both;
 }

 /* .hiramin{font-family: "ヒラギノ明朝 ProN W3", "HiraMinProN-W3","ＭＳ Ｐ明朝", "MS PMincho"} */
 /* .mincho {font-family:"游明朝", YuMincho, "ヒラギノ明朝 ProN W3", "Hiragino Mincho ProN", "HG明朝E", "ＭＳ Ｐ明朝", serif;} */
 /* .text-orange{color: #fd9429;} */
 /* qa
    ----------------------------------*/

 .qa_tx {
   font-size: 16px;
 }

 .qa a .btn {
   padding: 10px 80px 10px;
   margin: 10px 30px;
   color: #666;
   font-size: 20px;
   background: #fff;
   display: inline-block;
   border: 1px solid #aaa;
   border-radius: 3px;
   float: right;
 }

 .qa a .btn:after {
   content: "\f0da";
   margin: 0 5px;
   font-size: 18px;
   line-height: 1;
   margin: 0 10px;
   display: inline-block;
   font: normal normal normal 14px/1 FontAwesome;
   font-size: inherit;
   text-rendering: auto;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
 }

 .qa a:hover .btn {
   background: #ffa237;
 }

 .qa_list {
   margin-bottom: 30px;
 }

 .qa_list dt {
   font-size: 24px;
   color: #fd9429;
   margin-top: 16px;
   border-bottom: solid #fd9429 2px;
 }

 .qa_list dd {
   width: 48%;
   float: left;
   margin-right: 10px;
   margin-bottom: 5px;
   position: relative;
 }

 .qa_list dd a {
   font-size: 14px;
   background: #eee;
   position: relative;
   padding: 10px;
 }

 .qa_list dd a:after {
   position: absolute;
   right: 0;
   content: "\f0d7";
   margin: 0 5px;
   font-size: 18px;
   line-height: 1;
   margin: 0 10px;
   display: inline-block;
   font: normal normal normal 14px/1 FontAwesome;
   font-size: inherit;
   text-rendering: auto;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
 }

 .qa_list dd:hover {
   background: #fafafa;
 }

 .qa h3 {
   font-size: 26px;
   border-bottom: 2px solid #666;
   margin-top: 30px;
   color: #666;
 }

 .qa h4,
 .qa h5 {
   font-size: 26px;
   border-bottom: 2px solid #fd9429;
   margin-top: 50px;
   color: #fd9429;
 }

 .waku {
   margin-top: 20px;
   width: auto;
   height: auto;
   padding: 3%;
   text-align: left;
   color: #333333;
   border: 2px solid #ccc;
   border-radius: 10px;
   -webkit-border-radius: 10px;
   -moz-border-radius: 10px;
 }

 .qa_box dt {
   min-height: 50px;
   height: auto !important;
   height: 40px;
   border-bottom: 1px dotted #ccc;
   padding-left: 50px;
   padding-top: 10px;
   color: #666;
   background: url(/assets/img/qaQ.jpg) no-repeat 3px 5px;
 }

 .qa_box dd {
   text-align: left;
   min-height: 40px;
   height: auto !important;
   height: 40px;
   padding: 10px 0px 0px 50px;
   margin-top: 5px;
   background: url(/assets/img/qaA.jpg) no-repeat 3px 5px;
 }

 .qa_box strong {
   color: #EB7701;
 }

 .main-heading {
   padding: 15px 0 5px;
   margin-bottom: 50px;
   text-align: center;
   /* border-bottom: 1px solid #000; */
   position: relative;
 }

 .main-heading:after {
   content: '';
   width: 38px;
   height: 20px;
   margin-left: -10px;
   background: url(/assets/img/main_heading_bg.jpg) no-repeat;
   position: absolute;
   left: 50%;
   bottom: -20px;
 }

 .main-heading p {
   margin-bottom: 5px;
   color: #616161;
   font-size: 22px;
   position: relative;
 }

 .main-heading p:after {
   content: '';
   width: 50px;
   margin-left: -25px;
   /* border-bottom: 1px solid #000; */
   position: absolute;
   left: 50%;
   bottom: 1px;
 }

 .main-heading h2 {
   font-size: 36px;
 }

 @media only screen and (max-width: 600px) {
   body {min-width: 100%;}
   .inner{width: 100%;}

   /* qa
      ----------------------------------*/
   .qa {
     padding: 3%;
   }

   .qa_tx {
     font-size: 16px;
   }

   .qa a .btn {
     padding: 3%;
     margin: 3% 3%;
     color: #666;
     font-size: 20px;
     background: #fff;
     display: inline-block;
     border: 1px solid #aaa;
     border-radius: 3px;
     float: right;
   }

   .qa a .btn:after {
     content: "\f0da";
     margin: 0 1%;
     font-size: 18px;
     line-height: 1;
     margin: 0 10px;
     display: inline-block;
     font: normal normal normal 14px/1 FontAwesome;
     font-size: inherit;
     text-rendering: auto;
     -webkit-font-smoothing: antialiased;
     -moz-osx-font-smoothing: grayscale;
   }

   .qa a:hover .btn {
     background: #ffa237;
   }

   .qa_list {
     margin-bottom: 3%;
   }

   .qa_list dt {
     font-size: 24px;
     color: #fd9429;
     margin-top: 3%;
     border-bottom: solid #fd9429 2px;
   }

   .qa_list dd {
     width: 100%;
     float: left;
     margin-right: 3%;
     margin-bottom: 5px;
     position: relative;
   }

   .qa_list dd a {
     font-size: 14px;
     background: #eee;
     position: relative;
     padding: 3%;
   }

   .qa_list dd a:after {
     position: absolute;
     right: 0;
     content: "\f0d7";
     margin: 0 1%;
     font-size: 18px;
     line-height: 1;
     margin: 0 10px;
     display: inline-block;
     font: normal normal normal 14px/1 FontAwesome;
     font-size: inherit;
     text-rendering: auto;
     -webkit-font-smoothing: antialiased;
     -moz-osx-font-smoothing: grayscale;
   }

   .qa_list dd:hover {
     background: #fafafa;
   }

   .qa h3 {
     font-size: 26px;
     border-bottom: 2px solid #666;
     margin-top: 3%;
     color: #666;
   }

   .qa h4,
   .qa h5 {
     font-size: 26px;
     border-bottom: 2px solid #fd9429;
     margin-top: 3%;
     color: #fd9429;
   }

   .waku {
     width: auto;
     height: auto;
     padding: 3%;
     text-align: left;
     color: #333333;
     border: 2px solid #ccc;
     border-radius: 10px;
     -webkit-border-radius: 10px;
     -moz-border-radius: 10px;
   }

   .qa_box dt {
     min-height: 50px;
     height: auto !important;
     height: 40px;
     border-bottom: 1px dotted #ccc;
     padding-left: 50px;
     padding-top: 10px;
     color: #666;
     background: url(/assets/img/qaQ.jpg) no-repeat 3px 5px;
   }

   .qa_box dd {
     text-align: left;
     min-height: 40px;
     height: auto !important;
     height: 40px;
     padding: 3% 0px 0px 50px;
     margin-top: 1%;
     background: url(/assets/img/qaA.jpg) no-repeat 3px 5px;
   }

 }

 @media (min-width: 601px) {
   #faqpage {
     margin-top: 80px;
     /* to deal with floating menu*/
   }
 }


 .faqsection {
   margin-top: 60px;
 }

 .container {
   /* width: 960px; */
   margin: 0 auto;
 }




 /* scMenu */
 $dropdownmenu-bgcolor: #aaa;
 $menutype-color: #555;
 $menutype-color-eng: $dropdownmenu-bgcolor;
 $page-width: 960px;
 .new-gif {
   width: 24px;
 }
 a {
   cursor: pointer;
 }
 .horizontal-logo {
   cursor: pointer;
   display: flex;
   // background: #ddd;
   width: $page-width;
   justify-content: center;
   // justify-content: flex-start;
   // center .horizontal-logo to page
   // https://cotodama.co/position-absolute-center/
   position: absolute;
   left: 0;
   right: 0;
   top: 22px;
   margin: auto;
   img {
     // display: block;
     width: 270px;
   }
 }

 // dropdown menu section
 .menu li a {
   padding-left: 15px;
   padding-right: 15px;
 }
 .menu li a img{
   margin-top: -5px;
 }
 .menubutton_wrapper {
   /* padding-top: 30px;
      padding-left: 30px; */
   margin-top: 25px;
   margin-left: 15px;
   margin-bottom: -45px;
   display: flex;
   // justify-content: space-between;
   align-items: center;
   .menubutton {
     margin-top: 5px;
     margin-bottom: 5px;
     font-family: sans-serif;
     font-size: 30px;
   }
   img {
     display: block;
     margin-right: 10px;
     width: 250px;
   }
 }
 @media (min-width: 601px) {
   .menubutton {
     display: none;
   }
 }

 @media screen and (max-width: 1450px) {
   .horizontal-logo {
     /* stop it from colliding with faq_contact_recruit */
     justify-content: flex-start;
     margin-left: 15px;
   }
 }
 .topmenu li a {
   font-size: 0.8em;
   display: block;
   text-decoration: none;
   color: #47a3da;
   margin-right: 0px;
   border-right: 1px solid #999;
   padding: 0em 0em;
 }
 .menu-section {
   margin-top: -28px;
 }
 .menu-back {
   margin-top: -45px;
   z-index: -10;
 }
 @media (max-width: 600px) {
   .menubutton {
     margin: 0 auto;
     margin-top: 5px;
     margin-bottom: 5px;
     margin-left: 10px;
     font-family: sans-serif;
     font-size: 30px;
   }
   .menu-section {
     width: 100%;
     background-color: #fff;
     opacity: 0.95;
     font-size: 0.8em;
     margin-top: -88px;
     filter: drop-shadow(5px 5px 5px rgba(0,0,0,0.2));
   }
   .menu li a {
     margin-left: 30px;
   }
   .topmenu li a {
     font-size: 1em;

   }
 }

 .hide {
   /* display: none; */
 }



 @media (max-width: 600px) {

 }

</style>
